export { default } from "./MedicalInfo";
